import { CloseIconButton } from 'shared/ui/buttons/iconButtons/closeButton';
import { BasicCard } from 'shared/ui/cards/basicCard';
import { Flex } from 'shared/ui/flex';
import { BookIcon, BookWhiteIcon } from 'shared/ui/icons/book';
import { Typography } from 'shared/ui/typography';
import { ButtonsWrapper, CardContent, Container } from './styles';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';
import { useModal } from 'shared/lib/modal';
import { usePerson } from 'entities/person';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	resetBookingData,
	resetOrderDetail,
	selectBookingApplicationMod,
	selectBookingThreadMod,
	selectOrderBookingData,
	selectOrderDetail,
	setBookingApplicationMod,
	setBookingThreadMod,
	useOrderInfoWithoutError,
	useOrderState,
  selectInitialOrderBookingData
} from 'entities/orders';
import { FC, useEffect, useMemo, useState } from 'react';
import { usePaginationFilterPersons } from 'shared/lib/pagination';
import { PaginationHook } from 'shared/lib/pagination';
import { compareOrderChanges } from 'widgets/booking/lib/utils/compareOrderChanges';
import { ModalProvider } from 'shared/ui/modal';
import { OrderDetailCloseConfirm } from 'widgets/orderDetail/ui/buttons/orderDetailCloseConfirm';
import { useBookingEffects } from 'widgets/booking/lib/hooks/useBookingEffects';
import { useBookingReadyCheck } from 'widgets/booking/lib/hooks/useBookingReadyCheck';
import { useClientForm } from 'features/booking/BookingClientForm';
import { useBookingTimeExpired } from 'features/booking/slots';
import { existsChanges } from 'widgets/booking/lib/utils/existsChanges';
import { selectSettings } from 'entities/settings/model/selector';
import { ArrowTopIconButton } from 'shared/ui/buttons/iconButtons/arrowTopIconButton';
// import { useTimeslot } from 'entities/toolbar/timeslots';
import { compareBookingDatas } from 'widgets/booking/lib/utils/compareBookingDatas';
import { selectBookingIsEdit, selectBookingIsNew } from 'entities/orders/model/selectors';
import { setBookingIsEdit, setBookingIsNew } from 'entities/orders/model/ordersSlice';
import { useEscapeByOverlays } from 'shared/lib/modal/hooks/useEscapeByOverlays';

interface HeaderProps {
	prohibitToClose: boolean;
	toProhibitClose: (isClose?: boolean) => void;
}

export const Header: FC<HeaderProps> = ({
	prohibitToClose,
	toProhibitClose,
}) => {
	const { closeModal } = useModal();
	const {
		setOpenPersonBook,
		setSearchMode,
		setPerson,
		isOpenPersonBook,
		searchMode,
	} = usePerson();
	const orderInfo = useOrderInfoWithoutError();
	const dispatch = useAppDispatch();
	const [headerTitle, setHeaderTitle] = useState('Новое бронирование');
	const orderDetail = useAppSelector(selectOrderDetail);
	const { isWaitingList } = useOrderState(orderDetail);
	const { fetchDataWithDispatch } =
		usePaginationFilterPersons() as PaginationHook;
	const applicationMod = useAppSelector(selectBookingApplicationMod);
	const settings = useAppSelector(selectSettings);
	const bookingData = useAppSelector(selectOrderBookingData);
	const bookingDataInitial = useAppSelector(selectInitialOrderBookingData);
	const [isOpenModalClose, setOpenModalClose] = useState(false);
	const hasChanges = !compareOrderChanges(orderDetail, bookingData);
  const hasDatasChanges = !compareBookingDatas(bookingDataInitial || null, bookingData)
	const bookingThreadMod = useAppSelector(selectBookingThreadMod);
  const isNew = useAppSelector(selectBookingIsNew);
  const isEdit = useAppSelector(selectBookingIsEdit);
	const { isBookingTimeExpired } = useBookingTimeExpired();

	const { saveOrderOrBook, isDisabledBooking } =
		useBookingEffects(toProhibitClose);
	const { requireBook, resourcesCompare } = useBookingReadyCheck();
	const { bookingBtnIsActive } = useClientForm();
  // const { toTodayTimeSlot } = useTimeslot();

	const showHidePersonBookHandler = () => {
		if (!applicationMod) {
			if (searchMode === 'searchByName') {
				if (isOpenPersonBook) {
					setOpenPersonBook(false);
				} else {
					setOpenPersonBook(true);
				}
			} else {
				setOpenPersonBook(true);
				setSearchMode('searchByName');
			}

			fetchDataWithDispatch({ search: '', page: 1 });
		}
	};

	const closeBooking = () => {
		if (prohibitToClose) {
			return;
		}

		if (applicationMod) {
			dispatch(setBookingApplicationMod({ isWork: false }));
		}
    if (isNew) {
      dispatch(setBookingIsNew({isNew:false}))
    }
    
    if (isEdit) {
      dispatch(setBookingIsEdit({isEdit: false}));
    }

		//TODO нужно сделать чтобы сброс работал но чтобы окно заказа оставалось
		//открытым после выхода
		if (!isWaitingList) {
			orderInfo?.close();
			dispatch(resetBookingData());
			dispatch(resetOrderDetail());
			setPerson(null);
			dispatch(setBookingThreadMod({ isWork: false }));
		}

		closeModal();
	};

	const buttonDisabled = useMemo(() => {
		if (applicationMod) {
			if (compareOrderChanges(orderDetail, bookingData)) {
				return true;
			}
			return false;
		}

		if (bookingData.id && bookingBtnIsActive) {
			return true;
		}

		if (isDisabledBooking) {
			return true;
		}

		if (isBookingTimeExpired()) {
			return true;
		}

		if (
			!applicationMod &&
			compareOrderChanges(orderDetail, bookingData) &&
			resourcesCompare
		) {
			return true;
		}
	}, [
		bookingBtnIsActive,
		bookingData,
		isDisabledBooking,
		applicationMod,
		isBookingTimeExpired,
		orderDetail,
		resourcesCompare,
	]);

	const handleClose = () => {
    if (orderDetail) {
      if (isWaitingList) {
        if (applicationMod && hasChanges) {
          setOpenModalClose(true);

          return;
        }

        if (!applicationMod && (hasChanges || requireBook)) {
          setOpenModalClose(true);

          return;
        }
      } else {
        if (hasChanges || !resourcesCompare) {
          setOpenModalClose(true);

          return;
        }
      }
    } else {
      if (applicationMod) {
        if (existsChanges(bookingData, settings?.default_participants_count)) {
          setOpenModalClose(true);

          return;
        }
      } else {
        if ((!buttonDisabled || existsChanges(bookingData, settings?.default_participants_count)) && !bookingThreadMod) {
          setOpenModalClose(true);

          return;
        }
      }
    }

		orderInfo?.setSelectedId(0);
    // toTodayTimeSlot();
		closeBooking();
	};

	const backToEdit = () => {
		setOpenModalClose(false);
	};

	const saveEditing = () => {
    if (orderDetail) {
      if (!hasChanges) {
        return closeEdit();
      }
    } else {
      if (!hasDatasChanges) {
        return closeEdit();
      }
    }
		localStorage.setItem('booking', JSON.stringify(bookingData));
		closeBooking();
		setOpenModalClose(false);
	}

	const closeEdit = () => {
		closeBooking();
		orderInfo?.setSelectedId(0);
		setOpenModalClose(false);
		localStorage.removeItem('booking');
		localStorage.removeItem('favoriteSavedTime');
	};

	const saveOrder = async () => {
		await saveOrderOrBook();
	};

  useEscapeByOverlays('booking-form', handleClose);

	useEffect(() => {
		if (orderDetail && !applicationMod) {
			setHeaderTitle(
				`${orderDetail.status === 'waiting_list'
					? 'Заявка'
					: 'Бронирование'
				} ${orderDetail.id.toString()}`,
			);
		}

		if (applicationMod) {
			if (bookingData?.id) {
				setHeaderTitle(`Заявка № ${bookingData.id}`);
			} else {
				setHeaderTitle('Новая заявка');
			}
		}
		// eslint-disable-next-line
	}, [orderDetail, applicationMod]);

	return (
		<Container>
			<Container>
				<Flex $justify="space-between">
					{/* TODO отрефакторить сделать один компонент разные кейсы разные пропсы */}
					{!isOpenPersonBook || searchMode === 'searchByPhone' ? (
						<ButtonOutlined
							color={'main'}
							onClick={showHidePersonBookHandler}
						>
							<Flex
								$gap="8px"
								$alignItems="center"
								$cursor="pointer"
							>
								<BookIcon />
								<Typography
									mode={'h2'}
									colorVariant={'main'}
									isBold={true}
								>
									Гости
								</Typography>
							</Flex>
						</ButtonOutlined>
					) : (
						isOpenPersonBook &&
						searchMode === 'searchByName' && (
							<ButtonContained
								color={'main'}
								onClick={showHidePersonBookHandler}
							>
								<Flex
									$gap="8px"
									$alignItems="center"
									$cursor="pointer"
								>
									<BookWhiteIcon />
									<Typography
										mode={'h2'}
										colorVariant={'white'}
										isBold={true}
									>
										Гости
									</Typography>
								</Flex>
							</ButtonContained>
						)
					)}
					<ButtonsWrapper>
						{!bookingThreadMod && <ArrowTopIconButton onClick={saveEditing} />}
						<CloseIconButton onClick={handleClose} />
					</ButtonsWrapper>
					{isOpenModalClose && (
						<ModalProvider openByDefault>
							<OrderDetailCloseConfirm
								order={orderDetail}
								applicationMod={applicationMod}
								save={saveOrder}
								back={backToEdit}
								close={closeEdit}
							/>
						</ModalProvider>
					)}
				</Flex>
			</Container>
			<BasicCard fitContent={true}>
				<CardContent>
					<Typography mode={'large'} colorVariant={'main'}>
						{headerTitle}
					</Typography>
				</CardContent>
			</BasicCard>
		</Container>
	);
};
